import { useState, useEffect } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import VSolonCard from "../Cards/VSolonCard";
import ScrollToTop from "../ScrollToTop";

const ViewCase = () => {
  const [singleCase, setSingleCase] = useState();
  const [caseHistory, setCaseHistory] = useState(undefined);
  const [historyError, setHistoryError] = useState("");
  let params = useParams();
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  const location = useLocation();
  const [singleUpdates, setSingleUpdates] = useState([]);
  const [loading, setLoading] = useState();
  useEffect(() => {
    let title = "";
    if (singleCase?.note !== undefined && singleCase?.note?.trim() !== "") {
      title = title + singleCase.note + " | ";
    }
    title =
      title +
      singleCase?.court +
      " | " +
      singleCase?.gak +
      "/" +
      singleCase?.year +
      " | MySolon.gr";

    if (!singleCase) {
      title = "Δεν βρέθηκε η υπόθεση | MySolon.gr";
    }
    document.title = title;
  }, [location, singleCase]);

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();

    const getCase = async () => {
      try {
        setLoading(true);
        setHistoryError("");

        const response = await axiosPrivate.get(`/cases/${params.caseId}`, {
          signal: controller.signal,
        });
        const [updatesResult, historyResult] = await Promise.allSettled([
          axiosPrivate.get(`/gakupd/${params.caseId}`, {
            signal: controller.signal,
          }),
          axiosPrivate.get(`/cases/${params.caseId}/history`, {
            signal: controller.signal,
          }),
        ]);

        if (!isMounted) {
          return;
        }

        setSingleCase(response.data);
        setSingleUpdates(
          updatesResult.status === "fulfilled" && Array.isArray(updatesResult.value?.data)
            ? updatesResult.value.data
            : []
        );

        if (historyResult.status === "fulfilled") {
          setCaseHistory(historyResult.value?.data?.data ?? null);
        } else {
          console.error(historyResult.reason);
          setCaseHistory(null);
          setHistoryError(
            "Το ακριβές ιστορικό δεν ήταν διαθέσιμο. Προβάλλονται μόνο οι κλασικές ενημερώσεις."
          );
        }

        setLoading(false);
      } catch (err) {
        console.error(err);
        navigate("/login", { state: { from: location }, replace: true });
      }
    };

    getCase();

    return () => {
      isMounted = false;
      controller.abort();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  return loading ? (
    <h2>Ανακτώνται τα δεδομένα... Παρακαλώ περιμένετε...</h2>
  ) : singleCase ? (
    <div>
      <ScrollToTop />
      <VSolonCard
        singleCase={singleCase}
        singleUpdates={singleUpdates}
        historyData={caseHistory}
        historyError={historyError}
        historyLoading={caseHistory === undefined}
      />
    </div>
  ) : (
    <h2>Δεν βρέθηκε η υπόθεση.</h2>
  );
};

export default ViewCase;
